// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"80":"0e034acd","472":"0e034acd","749":"3b53517f"}[chunkId] + ".chunk.css";
};